import { CheckOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

import { useToken } from '../theme';

export type BooleanRendererProps = {
  value: boolean;
};

export const BooleanRenderer = ({ value }: BooleanRendererProps) => {
  const { token } = useToken();

  if (value) {
    return (
      <Tag color={token['bright-success']} style={{ margin: 0 }} icon={<CheckOutlined title="Yes" />}>
        Yes
      </Tag>
    );
  }

  return (
    <Tag color={token['bright-warning']} style={{ margin: 0 }}>
      No
    </Tag>
  );
};
